// extracted by mini-css-extract-plugin
export default {"container":"Mba-z","creativeContainer":"Nba-z","copy":"Oba-z","cta":"Pba-z","disabled":"Qba-z","flipped":"Rba-z","productCard":"Sba-z"};